module.exports = __webpack_public_path__ + "static/media/logo_mob.8cd081c5.svg";